import {
    ESPACOTRACK_EXCLUIR_NOTA,
    ESPACOTRACK_EXCLUIR_NOTA_LOADING,
    ESPACOTRACK_LIST,
    ESPACOTRACK_LOADING,
    ESPACOTRACK_PARCEIRO,
    ESPACOTRACK_PARCEIRO_LOADING,
    ESPACOTRACK_REMOVE,
    ESPACOTRACK_SHOW_OCULT,
    ESPACOTRACK_VENDEDORES,
    ESPACOTRACK_FORMULARIOS_LIST,
    ESPACOTRACK_FORMULARIOS_LIST_LOADING,
    ESPACOTRACK_FORMULARIO_OCULTAR,
    ESPACOTRACK_FORMULARIO_OCULTAR_LOADING,
    ESPACOTRACK_FORMULARIO_REMOVE,
    ESPACOTRACK_LIBERACAO,
    ESPACOTRACK_LIBERACAO_LOADING,
    ESPACOTRACK_IMAGEM,
    ESPACOTRACK_IMAGEM_LOADING
} from '../actions/ActionsTypes';

const INITIAL_STATE = {
    entregas: [],
    vendedores: [],
    isloading: true,
    parceiro: [],
    isloadingParceiro: false,
    exluirNota: [],
    showOcult: 0,
    isLoadingExcluir: true,
    formularios: [],
    formulariosAtivos: [],
    formulariosOcultos: [],
    isloadingFormularios: true,
    formularioOcultar: [],
    isloadingFormularioOcultar: false,
    liberacao: [],
    isloadingLiberacao: false,
    imagem: [],
    imagemloading: false,
}

const getFormularioIdfec = (formulario) => {
    const idfec = Number(formulario?.idfec);
    return Number.isFinite(idfec) ? idfec : 0;
};

const ordenarFormulariosPorIdfecDesc = (formularios) => [...formularios].sort((a, b) => getFormularioIdfec(b) - getFormularioIdfec(a));
const combinarFormularios = (ativos, ocultos) => ordenarFormulariosPorIdfecDesc([...(ativos || []), ...(ocultos || [])]);

export default (state = INITIAL_STATE, action) => {


    switch (action.type) {

        case ESPACOTRACK_LIST:
            return { ...state, entregas: action.payload }
        case ESPACOTRACK_LOADING:
            return { ...state, isloading: action.payload }
        case ESPACOTRACK_VENDEDORES:
            return { ...state, vendedores: action.payload }
        case ESPACOTRACK_PARCEIRO:
            return { ...state, parceiro: action.payload }
        case ESPACOTRACK_PARCEIRO_LOADING:
            return { ...state, isloadingParceiro: action.payload }
        case ESPACOTRACK_EXCLUIR_NOTA:
            return { ...state, exluirNota: action.payload }
        case ESPACOTRACK_EXCLUIR_NOTA_LOADING:
            return { ...state, isLoadingExcluir: action.payload }
        case ESPACOTRACK_SHOW_OCULT:
            return {
                ...state,
                showOcult: action.payload,
                formularios: state.formulariosAtivos
            }

        case ESPACOTRACK_FORMULARIOS_LIST: {
            const showOcultFormularios = action.payload?.showOcult === 1 || action.payload?.showOcult === '1' ? 1 : 0;
            const dadosFormularios = Array.isArray(action.payload?.dados) ? action.payload.dados : [];

            if (showOcultFormularios === 1) {
                return {
                    ...state,
                    formulariosOcultos: dadosFormularios,
                    formularios: combinarFormularios(state.formulariosAtivos, dadosFormularios)
                }
            }

            return {
                ...state,
                formulariosAtivos: dadosFormularios,
                formularios: state.showOcult === 1 ? combinarFormularios(dadosFormularios, state.formulariosOcultos) : dadosFormularios
            }
        }

        case ESPACOTRACK_FORMULARIOS_LIST_LOADING:
            return { ...state, isloadingFormularios: action.payload }

        case ESPACOTRACK_FORMULARIO_OCULTAR:
            return { ...state, formularioOcultar: action.payload }

        case ESPACOTRACK_FORMULARIO_OCULTAR_LOADING:
            return { ...state, isloadingFormularioOcultar: action.payload }

        case ESPACOTRACK_FORMULARIO_REMOVE: {
            const idfecRemover = Number(action.payload);
            const removeFormulario = (lista) => Array.isArray(lista)
                ? lista.filter((formulario) => Number(formulario.idfec) !== idfecRemover)
                : [];
            const formularioOcultado = [
                ...(state.formulariosAtivos || []),
                ...(state.formulariosOcultos || [])
            ].find((formulario) => Number(formulario.idfec) === idfecRemover);
            const formularioOcultadoAtualizado = formularioOcultado
                ? { ...formularioOcultado, is_ocult: 1 }
                : null;
            const formulariosAtivos = removeFormulario(state.formulariosAtivos);
            const formulariosOcultosBase = removeFormulario(state.formulariosOcultos);
            const formulariosOcultos = formularioOcultadoAtualizado
                ? [...formulariosOcultosBase, formularioOcultadoAtualizado]
                : formulariosOcultosBase;

            return {
                ...state,
                formulariosAtivos,
                formulariosOcultos,
                formularios: state.showOcult === 1 ? combinarFormularios(formulariosAtivos, formulariosOcultos) : formulariosAtivos
            }
        }

        case ESPACOTRACK_LIBERACAO:
            return { ...state, liberacao: action.payload }

        case ESPACOTRACK_LIBERACAO_LOADING:
            return { ...state, isloadingLiberacao: action.payload }

        case ESPACOTRACK_IMAGEM:
            return { ...state, imagem: action.payload }

        case ESPACOTRACK_IMAGEM_LOADING:
            return { ...state, imagemloading: action.payload }

        case ESPACOTRACK_REMOVE:
            console.log('chegou aqui nota reducer', action.payload);
            return {
                ...state,
                entregas: state.entregas.filter((entrega) => entrega.nunota !== action.payload),
            };

        default:
            return state;
    }
}
